var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("h1", { staticClass: "subtitle" }, [
          _vm._v("Extra Vehicle Information"),
        ]),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Quote No")]),
            _c("span", [_vm._v(_vm._s(_vm.quote.quoteNo))]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Customer")]),
            _c("span", [_vm._v(_vm._s(_vm.customer.fullname))]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Rego")]),
            _c("span", [_vm._v(_vm._s(_vm.vehicle.rego))]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Model")]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.vehicle.model.make) +
                  " " +
                  _vm._s(_vm.vehicle.model.model)
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Transmission")]),
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.transmissionType,
                        expression: "innerValue.transmissionType",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.innerValue,
                          "transmissionType",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "A" } }, [
                      _vm._v("Automatic"),
                    ]),
                    _c("option", { attrs: { value: "M" } }, [_vm._v("Manual")]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("VIN")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.innerValue.vinChassis,
                    expression: "innerValue.vinChassis",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text" },
                domProps: { value: _vm.innerValue.vinChassis },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.innerValue, "vinChassis", $event.target.value)
                  },
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [_vm._v("Odometer")]),
                _c("vue-numeric", {
                  staticClass: "input",
                  attrs: { precision: 0, separator: "" },
                  model: {
                    value: _vm.innerValue.odometer,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "odometer", _vm._n($$v))
                    },
                    expression: "innerValue.odometer",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Build Month")]),
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.monthOfManufacture,
                        expression: "innerValue.monthOfManufacture",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.innerValue,
                          "monthOfManufacture",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.months, function (m, key) {
                    return _c(
                      "option",
                      { key: key, domProps: { value: key } },
                      [_vm._v(_vm._s(m))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Damage Description"),
              ]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.innerValue.damageDescription,
                    expression: "innerValue.damageDescription",
                  },
                ],
                staticClass: "textarea",
                attrs: { name: "", rows: "3" },
                domProps: { value: _vm.innerValue.damageDescription },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.innerValue,
                      "damageDescription",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [_vm._v("Cylinders")]),
                _c("vue-numeric", {
                  staticClass: "input",
                  attrs: { precision: 0, separator: "" },
                  model: {
                    value: _vm.innerValue.numberOfCylinders,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "numberOfCylinders", _vm._n($$v))
                    },
                    expression: "innerValue.numberOfCylinders",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [_vm._v("Fuel Level")]),
                _c("vue-numeric", {
                  staticClass: "input",
                  attrs: {
                    precision: 0,
                    max: 100,
                    symbol: "%",
                    "symbol-position": "suffix",
                    separator: "",
                  },
                  model: {
                    value: _vm.innerValue.fuelLevel,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "fuelLevel", _vm._n($$v))
                    },
                    expression: "innerValue.fuelLevel",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Colour")]),
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.color,
                        expression: "innerValue.color",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.innerValue,
                          "color",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.pnetColourCodeTypes, function (colour, prop) {
                    return _c(
                      "option",
                      { key: prop, domProps: { value: colour } },
                      [_vm._v(_vm._s(colour))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [_vm._v("Build Year")]),
                _c("the-mask", {
                  staticClass: "input",
                  attrs: { placeholder: "e.g. 2000", mask: ["####"] },
                  nativeOn: {
                    blur: function ($event) {
                      return _vm.checkYear.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.innerValue.yearOfManufacture,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "yearOfManufacture", $$v)
                    },
                    expression: "innerValue.yearOfManufacture",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Old Damage Description"),
              ]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.innerValue.oldDamageDescription,
                    expression: "innerValue.oldDamageDescription",
                  },
                ],
                staticClass: "textarea",
                attrs: { name: "", rows: "3" },
                domProps: { value: _vm.innerValue.oldDamageDescription },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.innerValue,
                      "oldDamageDescription",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }